import React, { useState, useRef, useEffect } from "react";
import { MenuItem } from "react-bootstrap";

const MoreMenu = ({ row, index, isOpen, onToggle, onPrint, onRecovery, onRefund, onEditClick, onCancel }) => {
    const [menuPosition, setMenuPosition] = useState({ top: "0px", right: "0px" });
    const moreMenuRef = useRef(null); // Reference to the "More" button
    const menuRef = useRef(null);     // Reference to the dropdown menu

    // Function to calculate dropdown position, now shifted left
    const calculateMenuPosition = () => {
        const buttonRect = moreMenuRef.current.getBoundingClientRect();
        const menuHeight = 120; // Approximate dropdown height
        const viewportHeight = window.innerHeight;


        // Determine if menu should open above or below
        const top = (buttonRect.bottom + menuHeight > viewportHeight)
            ? `${buttonRect.top - menuHeight}px`
            : `${buttonRect.bottom}px`;

        const right = 0;

        setMenuPosition({ top, right });
    };

    const handleToggle = () => {
        calculateMenuPosition(); // Position the dropdown before toggling
        onToggle();              // Trigger parent's toggle state
    };

    // Close the menu if user clicks outside it
    const handleClickOutside = (e) => {
        if (
            menuRef.current &&
            !menuRef.current.contains(e.target) &&
            !moreMenuRef.current.contains(e.target)
        ) {
            onToggle(); // Close dropdown
        }
    };

    useEffect(() => {
        document.body.addEventListener("click", handleClickOutside);
        return () => {
            document.body.removeEventListener("click", handleClickOutside);
        };
    }, []);

    console.log(row, "MoreMenu row data");
    return (
        <div className="position-relative d-inline-block more-custom-table-btn"
            style={{
                position: 'relative',
            }}>
            <div
                ref={moreMenuRef}
                style={{ cursor: "pointer", color: "#007bff" }}
                onClick={handleToggle}
            >
                More <span style={{ fontWeight: "bold", fontSize: "16px" }}></span> <span style={{ fontSize: "14px" }}>▼</span>
            </div>

            {isOpen && (
                <div
                    ref={menuRef}
                    className="patient-search dropdown-menu show custom-more-dropdown bill-menu-set"
                    style={{
                        position: "absolute",
                        zIndex: 9999,
                        // top: menuPosition.top,
                        top: '0px',
                        right: '70px',
                        // right: menuPosition.right,
                        backgroundColor: "#fff",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        border: "1px solid #ddd",
                        borderRadius: "4px"
                    }}
                >
                    <MenuItem onClick={() => onPrint(row)}>
                        <span role="img" aria-label="print" style={{ filter: 'grayscale(100%)' }}>🖨️</span> Print
                    </MenuItem>
                    {row?.isToday && !row?.isCancelled && (

                        <>

                            <MenuItem onClick={() => onEditClick(row)}>
                                <span role="img" aria-label="edit" style={{ filter: 'grayscale(100%)' }}>✏️</span> Edit
                            </MenuItem>
                            <MenuItem onClick={() => onCancel(row)}>
                                <span role="img" aria-label="cancel" style={{ filter: 'grayscale(100%)' }}>❌</span> Cancel
                            </MenuItem>
                        </>

                    )}
                    {row?.totalRemainingAmount && Number(row?.totalRemainingAmount) > 0 && !row?.isCancelled && (
                        <MenuItem onClick={() => onRecovery(row)}>
                            <span role="img" aria-label="recovery" style={{ filter: 'grayscale(100%)' }}>↩️</span> Recovery
                        </MenuItem>
                    )}
                    {row?.isToday && !row?.isCancelled && (
                        <MenuItem onClick={() => onRefund(row)}>
                            <span role="img" aria-label="refund" style={{ filter: 'grayscale(100%)' }}>💸</span> Refund
                        </MenuItem>
                    )}
                </div>
            )
            }
        </div >
    );
};

export default MoreMenu;
